import axios from 'axios';
import useAuth from './useAuth';
import { useHttpErrorHandler } from "./useHttpErrorHandler";

export default function useUpdateUserProfile() {
  const { setUserContext } = useAuth();
  const { httpErrorHandler, errorStatus } = useHttpErrorHandler();

  const createAxiosInstance = () => {
    return axios.create({
      baseURL: `${process.env.REACT_APP_FEATURED_API}auth/profile/`,
      headers: {
        Authorization: `JWT ${localStorage.getItem('token')}`,
      },
    });
  };

  const updateCoverageTopics = async (data) => {
    const axiosInstance = createAxiosInstance();
    try {
      await axiosInstance.put('coverage_topics/', {
        user_location_covered: data,
      });
      await setUserContext('no');
      return true;
    } catch (err) {
      httpErrorHandler();
      return false;
    }
  };

  /*
  we should update the user context object directly here (instead of doing it
  by calling setUserContext()), see below. navigation logic should be completely
  separate.
  */
  const updateProfile = async (data) => {
    const axiosInstance = createAxiosInstance();
    try {
      await axiosInstance.put('/', data);
      await setUserContext('/profile');
    } catch (err) {
      formatErrors(err);
      httpErrorHandler();
    }
  };


  /*
  we should update the user context object here. currently we are checking this
  return value and doing things like calling setUserContext('no') (which just
  makes a GET for the profile and sets the user context anyway) or directly
  updating the user context object after verifying the successful PUT. if the
  caller of this function fails to do one of those things then the user context
  object becomes out of sync with the DB.

  it would probably be better if we stop using setUserContext() like that in
  general. it combines syncing the user context object from the DB and doing a 
  redirect. we only need that logic (GET profile then redirect) upon login.
  after that, we can use these two updateProfile...() functions to perform
  synchronized updates to our user/profile model.

  see more comments in useAuth.js
  */
  const updateProfileWithoutPush = async (data) => {
    const axiosInstance = createAxiosInstance();
    try {
      await axiosInstance.put('/', data);
      return true;
    } catch (err) {
      formatErrors(err);
      httpErrorHandler();
      return false;
    }
  };

  const toTitleCase = (phrase) => {
    return phrase
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const formatErrors = (err) => {
    let messages = '';
    try {
      const keys = Object.keys(err.response.data);
      keys.forEach((bk) => {
        const errorList = err.response.data[bk];
        errorList.forEach((ck) => {
          const key =
            bk !== 'non_field_errors'
              ? toTitleCase(bk.replaceAll('_', ' ')) + ' : '
              : '';
          messages += key + ck + '<br>';
        });
      });
    } catch (error) {
      messages = 'Something bad happened';
    }
    document.getElementById('form-error').innerHTML = messages;
  };

  return {
    updateProfile,
    updateProfileWithoutPush,
    updateCoverageTopics,
  };
}
